import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTour } from '../../../contexts/TourContext';
import { FONT, TOUR_BAR_H, tourPalette } from '../tourTheme';
import { TOUR_Z } from '../tourZIndex';

// The instruction line on a real product page during a handoff. The step's
// actions live in TourAppBar, so this stays a hint and nothing more.
const TourTaskBanner = () => {
  const { active, phase, current } = useTour();
  const muiTheme = useTheme();
  if (!active || phase !== 'page' || !current?.task) return null;
  // Unlike the tour's own surfaces, this banner sits on a real product page and
  // is translucent — so it has to follow the app theme, not assume dark.
  const p = tourPalette(muiTheme.palette.mode === 'dark');

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'sticky',
        // Clears the fixed TourAppBar, which renders in this same phase.
        top: `${TOUR_BAR_H}px`,
        zIndex: TOUR_Z.tip,
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        p: '13px 24px',
        // Sticky, so the gap has to be a margin — the page content below would
        // otherwise sit flush against the banner.
        mb: '8px',
        flexWrap: 'wrap',
        background: p.softAccent,
        borderBottom: `1px solid ${p.accentMuted}`,
        backdropFilter: 'blur(6px)'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
        <Box
          sx={{
            font: `600 10px/1 ${FONT.mono}`,
            letterSpacing: '.1em',
            p: '5px 8px',
            borderRadius: '5px',
            background: p.accent,
            color: p.accentInk,
            whiteSpace: 'nowrap'
          }}
        >
          {current.tipTitle}
        </Box>
        <Box sx={{ font: `400 12.5px/1.4 ${FONT.body}` }}>{current.task}</Box>
      </Box>
    </Box>
  );
};

export default TourTaskBanner;
